module.exports = __webpack_public_path__ + "static/bookshelf-november-6c2f53091d8b4934cf99f3f80d7799dc.png";